export default __webpack_public_path__ + "static/media/user-image.60f83347.png";